import BaseStore from 'fluxible/addons/BaseStore';
import humps from 'humps';

interface Option {
    name: string;
    value: string;
}

class BriefStore extends BaseStore {
    static storeName = 'BriefStore';

    static handlers: { [key: string]: keyof BriefStore } = {
        LOAD_DRAFT_DATA: 'load',
        SAVE_DRAFT_SUCCESS: 'load',
        UPDATE_BRIEF: 'update',
    };

    briefData: { [key: string]: any } = {};
    languageOptions: Option[];
    industryOptions: Option[];
    hasStockQuestion = false;
    hasAiPreference = false;

    load(payload: {
        body: object;
        language_options: Option[];
        industry_options: Option[];
        has_stock_question: boolean;
        has_ai_preference: boolean;
    }) {
        this.briefData = humps.camelizeKeys(payload.body);

        if (payload.language_options) {
            this.languageOptions = payload.language_options;
        }

        if (payload.industry_options) {
            this.industryOptions = payload.industry_options;
        }

        if (payload.has_stock_question) {
            this.hasStockQuestion = payload.has_stock_question;
        }

        if (payload.has_ai_preference) {
            this.hasAiPreference = payload.has_ai_preference;
        }

        this.emitChange();
    }

    update(payload: { [key: string]: any }) {
        Object.keys(payload).map(key => {
            this.briefData[key] = payload[key];
        });

        this.emitChange();
    }
}

export default BriefStore;
